import { Component, h, Prop, Element, Listen, State } from '@stencil/core';

@Component({
  tag: 'anchor-accordion',
  shadow: true,
})
export class Accordion {
  private readonly cssClass = 'anchor-c-accordion';

  @Prop({reflect: true}) keepOpen = false;
  
  @Element() element: HTMLElement;

  @State() expanded: HTMLElement;
  
  @Listen('toggled')
  toggledHandler(e: CustomEvent) {
    if (e.detail.value) {
      // an accordion-item was expanded
      if(this.expanded && !this.keepOpen){
        this.expanded.removeAttribute('is-expanded');
      }
      this.expanded = e.target as HTMLElement;
    }
    // stop propagation so things don't break down with nested accordions
    e.preventDefault();
    e.stopImmediatePropagation();
  }

  render() {
    return (
      <div
        class={`${this.cssClass}`}
      >
        <slot/>
      </div>
    );
  }
}
